import { DELETE_LABEL, UNSHARE_LABEL } from '../../../common/ActionLabels';
import { shareChangesState } from '../../../common/ItemTools';
import { favoriteActionTitle } from '../FavoriteIcon';

/**
 * The ⋮ entries an author, site or list card offers. `collapsed` adds the
 * footer actions the card has no room for, the way the item card's own builder
 * does, so an action is never lost — only moved.
 *
 * `target` is what the handlers take, which is not always what the footer
 * reads: a list card merges its copies before rendering but still acts on the
 * unmerged record.
 */
export default function buildEntityMenuOptions(options) {
  const {
    target, hasPrivateData, hasPublicData, isFavorite, shareDiff,
    moderating, collapsed,
    onEdit, onDelete, onUnshare, onShare, onFavorite,
  } = options;

  const entries = [];
  if (collapsed && !moderating) {
    const shareIsMarker = hasPublicData && shareChangesState(shareDiff) === 'none';
    if (onShare && hasPrivateData && !shareIsMarker) {
      entries.push({
        label: hasPublicData ? 'Share changes' : 'Share',
        action: () => onShare(target),
      });
    }
    if (onFavorite) {
      entries.push({
        label: favoriteActionTitle(Boolean(isFavorite)),
        action: () => onFavorite(target),
      });
    }
  }
  if (onEdit) {
    entries.push({ label: 'Edit', action: () => onEdit(target) });
  }
  if (!moderating && onDelete && hasPrivateData) {
    entries.push({ label: DELETE_LABEL, action: () => onDelete(target) });
  }
  if (!moderating && onUnshare && hasPublicData) {
    entries.push({ label: UNSHARE_LABEL, action: () => onUnshare(target) });
  }
  return entries.map((entry, index) => ({ ...entry, id: index + 1 }));
}
